<template>
    <a
        class="card swiper-slide"
        :href="product.url"
        target="_blank"
    >
        <img :src="product.image_url" class="img" :alt="product.label" loading="lazy" />
        <div class="card-description">
            <div class="subtitle">{{ product.category }}</div>
            <div class="description">
                <h4 class="title">{{ product.label }}</h4>
                <div class="price">{{ product.price }} €</div>
            </div>
        </div>
    </a>
</template>

<script>
export default {
    props: {
        product: {
            type: Object,
            required: true,
        },
    },
};
</script>
